;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Icon, type IconName } from './icon'

/**
 * Wrapper for an icon inside a `<Button>` or `<Anchor>`
 *
 * @example
 * <Button>
 *   <ButtonIcon name="heroicons/solid/beaker" />
 *   Add to cart
 * </Button>
 */
export function ButtonIcon({ name }: { name: IconName }) {
  return <Icon name={name} className="block size-4.5 shrink-0" />
}
